"use strict";

;

(function ($) {
  // Strict Mode
  'use strict';

  var heroSlider = function heroSlider($scope, $) {
    var heroSwiper;
    var $this = $scope.find('.hero-slider');
    var $id_str = $this.attr('id');
    var $id = '#' + $this.attr('id');
    var $loop = $this.data('loop');
    var autoplay = $this.data('autoplay');
    var hero = $($id);

    if (autoplay) {
      var options = {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        direction: getDirection(),
        preloadImages: true,
        lazy: true,
        //effect: 'fade',
        loop: $loop ? $loop : false,
        pagination: {
          el: '.hero-swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.hswiper-button-prev-' + $id_str,
          prevEl: '.hswiper-button-next-' + $id_str
        }, on: {
          resize: function () {
            heroSwiper.changeDirection(getDirection());
          },
          init: function () {
            var index = this.activeIndex;
            $('.hero-captions__content')
              .removeClass('active')
              .eq(index)
              .addClass('active');
          }
        },
      };
    } else {
      var options = {
        direction: "vertical",
        preloadImages: true,
        //lazy: true,
        effect: 'fade',
        loop: $loop ? $loop : false,
        pagination: {
          el: '.hero-swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.hswiper-button-prev-' + $id_str,
          prevEl: '.hswiper-button-next-' + $id_str
        }
      };
    }


    function getDirection() {
      var windowWidth = window.innerWidth;
      var direction = window.innerWidth <= 760 ? 'horizontal' : 'vertical';

      return direction;
    }

    if ('undefined' === typeof Swiper) {
      const asyncSwiper = elementorFrontend.utils.swiper;
      new asyncSwiper($this, options).then((newSwiperInstance) => {
        heroSwiper = newSwiperInstance;
        heroSwiper.on('slideChange', function () {
          var index = this.activeIndex;
          $('.hero-captions__content')
            .removeClass('active')
            .eq(index)
            .addClass('active');
        });
      });
    } else {
      heroSwiper = new Swiper($this, options);
    }


  };

  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/pf-hero-slider.default', heroSlider);
  });
})(jQuery);
